import React from "react";
import { Popup } from ".";
import { TextDescription, TextExampleCode, TextExampleCodeValue, IconsContainer, IconContainer, TextDescriptionIcon, TextDescriptionMain } from "./stylePdrPopup";
import { ReactComponent as PdrTopIcon } from "../../static/images/pdrTop.svg";
import { ReactComponent as PdrRightIcon } from "../../static/images/pdrRight.svg";
import { ReactComponent as PdrLeftIcon } from "../../static/images/pdrLeft.svg";

export const PODPopup = ({ isOpen, close }) => {
    return (
        <React.Fragment>
            {isOpen && 
        <Popup
            isOpen={isOpen}
            close={close}
            buttonText="Ok! Ho capito"
            title="DOVE TROVO IL POD?"
            large={true}
        >
            <section>
                <TextDescriptionMain>
                    Il POD è il codice che identifica l'utenza elettrica. É univoco ed è un codice alfanumerico inizia
                    sempre con IT ed è seguito da altre cifre per un totale di 14-15 caratteri. Il Codice non cambia
                    anche se si cambia fornitore. Si trova tra i dati della fornitura indicati nella prima
                    pagina della bolletta o, più raramente, nelle seconda.
                </TextDescriptionMain>
                <TextDescription>
                    Cerca il tuo POD in uno dei seguenti punti della bolletta:
                </TextDescription>
            </section>
            <IconsContainer>
                <IconContainer>
                    <PdrTopIcon />
                    <TextDescriptionIcon>Sezione in alto (es.Enel, e.on, Edison, Iren, Acra)</TextDescriptionIcon>
                </IconContainer>
                <IconContainer>
                    <PdrRightIcon />
                    <TextDescriptionIcon>Colonna destra (es.A2A)</TextDescriptionIcon>
                </IconContainer>
                <IconContainer>
                    <PdrLeftIcon />
                    <TextDescriptionIcon>Colonna sinistra (es.Hera)</TextDescriptionIcon>
                </IconContainer>
            </IconsContainer>
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <TextExampleCode>ESEMPIO CODICE POD</TextExampleCode>
                <TextExampleCodeValue>IT************</TextExampleCodeValue>
            </section>
        </Popup>
            }
        </React.Fragment>
    )
}